import { generateActionForKey, generateActions } from "../generateActions";
import { eLichSuNapDuLieuActionsObj } from "../../action-types/quan-ly-dang-ky/ILichSuNapDuLieuActions";
import { NotifyHelper } from "../../../helpers/toast";

export const lichSuNapDuLieuActions = {
    ...generateActions(eLichSuNapDuLieuActionsObj, "LICH_SU_NAP_DU_LIEU"),
    ...generateActionForKey(eLichSuNapDuLieuActionsObj, "LICH_SU_NAP_DU_LIEU", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}